export function KeyboardHint() {
  return (
    <span className="hidden sm:inline-flex items-center gap-1.5 text-xs text-gray-400">
      Presioná
      <kbd className="inline-flex items-center justify-center rounded border border-gray-300 bg-gray-100 px-1.5 py-0.5 font-mono text-[11px] font-medium text-gray-500 shadow-sm">
        ?
      </kbd>
      para ver atajos
    </span>
  );
}
